<script>
export default {
    props: {
        fundclusters: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: "button"
        },
        selectedPOs: {
            type: Array,
            default: () => []
        },
        selectedItems: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        selectedOption(newVal) {
            if(newVal === 'cluster') {
                this.selectedCluster = this.fundclusters.length ? this.fundclusters[0].id : null;
            }else if(newVal === 'po') {
                this.inputtedPO = "";
            }
            this.$emit("update-option", newVal);
        }
    },
    data() {
        return {
            selectedCluster: '',
            selectedOption: "cluster",
            inputtedPO: "",
            mouseOverCart: false,
        };
    },
    methods: {
        generateRSMI(type) {
            if(type === 'po') {
                this.$emit("generate-rsmi", { 
                    type, pos: this.selectedPOs.map(x => {
                        return x.poId
                    }) 
                });
            }else if(type == 'items'){
                this.$emit("generate-rsmi", { 
                    type, items: this.selectedItems.map(x => {
                        return x.id
                    }) 
                });
            }else{
                this.$emit("generate-rsmi", { type, clusterId: this.selectedCluster });
            }
        },
        generateRSPI(type) {
            if(type === 'po') {
                this.$emit("generate-rspi", { 
                    type, pos: this.selectedPOs.map(x => {
                        return x.poId
                    }) 
                });
            }else if(type == 'items'){
                this.$emit("generate-rspi", { 
                    type, items: this.selectedItems.map(x => {
                        return x.id
                    }) 
                });
            }else{
                this.$emit("generate-rspi", { type, clusterId: this.selectedCluster });
            }
        },
        unCart(item) {
            this.$emit('uncart', item);
        },
        clearAllSelected() {
            this.$emit('clear-all');
        }
    },
};
</script>
<template>
  <div :class="{'position-fixed bottom-cart': type === 'cart'}">
    <template v-if="type === 'cart'">
        <template v-if="selectedPOs.length">
            <transition name="fade">
                <div 
                    @mouseenter="mouseOverCart = true" 
                    @mouseleave="mouseOverCart = false"
                    id="cartPopover"
                >
                    <span 
                        class="badge bg-danger rounded-pill position-fixed" 
                        style="bottom: 80px; left: 55px">
                        {{ selectedPOs.length }}
                    </span>
                    <div title="View Cart" class="avatar-sm mx-auto cursor-pointer" >
                        <span class="avatar-title rounded-circle bg-info">
                            <i 
                                class="mdi mdi-cart-outline font-size-24" 
                                :class="{ 'bx-tada': mouseOverCart }">
                            </i>
                        </span>
                    </div>
                </div>
            </transition>
            <b-popover
                target="cartPopover"
                triggers="click blur"
                placement="top"
                custom-class="popover-rsmi"
                v-if="selectedPOs.length" 
            >
                <div class="text-right mb-2">
                    <button class="btn btn-transparent btn-sm" @click="clearAllSelected"><i class="bx bx-x text-danger"></i>Clear All Selection</button>
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="py-2">P.O Number</th>
                            <th class="text-center py-2" style="width: 10px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="x in selectedPOs" :key="x.id">
                            <td class="py-2">{{ x.poNumber }}</td>
                            <td class="text-center py-2">
                                <i 
                                    title="Remove from Cart"
                                    class="bx bx-x text-danger cursor-pointer font-size-14"
                                    @click="unCart(x)"
                                ></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <small>Generate:</small>
                    <div class="d-flex gap-1">
                        <button type="button" class="btn btn-primary btn-block" @click="generateRSMI('po')">
                            <i class="bx bx-printer me-1"></i>RSMI
                        </button>
                        <button type="button" class="btn btn-success btn-block" @click="generateRSPI('po')">
                            <i class="bx bx-printer me-1"></i>RSPI
                        </button>
                    </div>
                </div>
            </b-popover>
        </template>
        <template v-if="selectedItems.length">
            <transition name="fade">
                <div 
                    @mouseenter="mouseOverCart = true" 
                    @mouseleave="mouseOverCart = false"
                    id="itemCartPopover"
                >
                    <span 
                        class="badge bg-danger rounded-pill position-fixed" 
                        style="bottom: 80px; left: 55px">
                        {{ selectedItems.length }}
                    </span>
                    <div title="View Cart" class="avatar-sm mx-auto cursor-pointer" >
                        <span class="avatar-title rounded-circle bg-warning">
                            <i 
                                class="mdi mdi-cart-outline font-size-24" 
                                :class="{ 'bx-tada': mouseOverCart }">
                            </i>
                        </span>
                    </div>
                </div>
            </transition>
            <b-popover
                target="itemCartPopover"
                triggers="click blur"
                placement="top"
                custom-class="popover-rsmi"
                v-if="selectedItems.length" 
            >
                <div class="text-right">
                    <button class="btn btn-transparent btn-sm" @click="clearAllSelected"><i class="bx bx-x text-danger"></i>Clear All Selection</button>
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="py-2">Item Description</th>
                            <th class="text-center py-2" style="width: 10px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="x in selectedItems" :key="x.id">
                            <td class="py-2">{{ x.description }}</td>
                            <td class="text-center py-2">
                                <i 
                                    title="Remove from Cart"
                                    class="bx bx-x text-danger cursor-pointer font-size-14"
                                    @click="unCart(x)"
                                ></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <small>Generate:</small>
                    <div class="d-flex gap-1">
                        <button type="button" class="btn btn-primary btn-block" @click="generateRSMI('items')">
                            <i class="bx bx-printer me-1"></i>RSMI
                        </button>
                        <button type="button" class="btn btn-success btn-block" @click="generateRSPI('items')">
                            <i class="bx bx-printer me-1"></i>RSPI
                        </button>
                    </div>
                </div>
            </b-popover>
        </template>
    </template>
    <template v-else>
        <button type="button" class="btn btn-primary" id="rsmiPopover">
        <i class="bx bx-printer"></i> Generate RSMI/RSPI
        </button>
        <b-popover
            :target="'rsmiPopover'"
            triggers="click blur"
            placement="left"
            custom-class="popover-rsmi"
        >
            <div class="mb-3">
                <label for="fundCluster" class="form-label mb-0">Select Generate Options</label>
                <select name="generateOptions" id="generateOptions" class="form-select" v-model="selectedOption">
                    <option value="cluster">By Fund Cluster</option>
                    <option value="po">By P.O</option>
                    <option value="items">By Requisition Items</option>
                </select>
            </div>
            <div class="mb-3" v-if="selectedOption === 'cluster'">
                <label for="fundCluster" class="form-label mb-0">Select Fund Cluster</label>
                <select name="fundCluster" id="fundCluster" class="form-select" v-model="selectedCluster">
                    <option disabled value="">-- Select Fund Cluster --</option>
                    <option v-for="cluster in fundclusters" :key="cluster.id" :value="cluster.id">
                        {{ cluster.cluster }}
                    </option>
                </select>
            </div>
            <div class="mb-3" v-if="selectedOption === 'po'">
               <p class="mb-0">Please select P.O's from the list (you can toggle the sky blue basket cart icon)</p>
            </div>
            <div class="mb-3" v-if="selectedOption === 'items'">
               <p class="mb-0">Please select Requisition Items from the list (you can toggle the yellow basket cart icon in each requisition)</p>
            </div>
            <div v-if="selectedCluster && selectedOption === 'cluster'">
                <small>Generate:</small>
                <div class="d-flex gap-1">
                    <button type="button" class="btn btn-primary btn-block" @click="generateRSMI('cluster')">
                        <i class="bx bx-printer me-1"></i>RSMI
                    </button>
                    <button type="button" class="btn btn-success btn-block" @click="generateRSPI('cluster')">
                        <i class="bx bx-printer me-1"></i>RSPI
                    </button>
                </div>
            </div>
        </b-popover>
    </template>
  </div>
</template>
<style lang="scss">
.popover-rsmi {
    max-width: 300px !important;  
    .popover-body {
        width: 300px !important;
    }
}
.bottom-cart{
    bottom: 50px;
    left: 25px;
    z-index: 1000;
}
</style>